<af-full-table
    class="w-100 h-100"
    [showImport]="false"
    [showExport]="false"
    [dataSource]="dataSource"
    (tableUpdateListener)="loadIncidents($event)"
    [filterEvent]="tableEvent.filter"
    [pageEvent]="tableEvent.page"
    [sortEvent]="tableEvent.sortBy"
    [totalElements]="totalElements"
    [filterFields]="filterFields"
    additionalSpinnerIds="trendIncidents"
    placeholderContext="trendIncidents"
    emptyStateIconName="ic_empty_state_no_data"
    emptyStateTitleTranslationKey="i18n_af_emptyStateSubtitleNoData"
    totalElementsTranslationKey="i18n_af_labelTotalElementsTrendIncidents"/>
